import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaFacebookF, FaInstagram, FaPinterestP, FaYoutube, FaWhatsapp } from "react-icons/fa";
import { FaThreads } from "react-icons/fa6";
import { Link } from "react-router-dom";

const Footer = () => {
		return(
				<footer className="footer">
      <Container>
        <Row>
          {/* About Us Section */}
          <Col lg={4}>
            <div className="footer-col first">
              <h6 className="text-dark">About Us</h6>
              <ul className="list-unstyled p-small">
                <li>Code Inputs</li>
                <li>www.codeinputs.com</li>
                <li>Email: codeinputs@gmail.com</li>
                <li>Contact: +91 7693890243</li>
              </ul>
            </div>
          </Col>

          {/* Quick Links Section */}
          <Col lg={4}>
            <div className="footer-col second">
              <h6 className="text-dark">Quick Links</h6>
              <ul className="list-unstyled p-small">
                <li><Link to="/" className="text-dark">Home</Link></li>
                <li><Link to="/about" className="text-dark">About Us</Link></li>
                <li><Link to="/contactus.html" className="text-dark">Contact Us</Link></li>
              </ul>
            </div>
          </Col>

          {/* Additional Links Section */}
          <Col lg={4}>
            <div className="footer-col second">
              <h6 className="text-dark">Links</h6>
              <ul className="list-unstyled p-small">
                <li><Link to="/terms.html" className="text-dark">Terms & Conditions</Link></li>
                <li><Link to="/privacy.html" className="text-dark">Privacy Policy</Link></li>
                <li><Link to="/disclaimer.html" className="text-dark">Disclaimer</Link></li>
                <li><Link to="/sitemap.html" className="text-dark">Sitemap</Link></li>
              </ul>
            </div>
          </Col>
        </Row>

        {/* Social Media Icons Section */}
        <Row className="text-center mt-3">
          <Col>
            <a href="https://www.facebook.com/profile.php?id=61561141336672" aria-label="facebook" className="mx-2" style={{color:"#1877F2"}}>
              <FaFacebookF size={24} />
            </a>
            <a href="https://www.instagram.com/codeinputs_24" aria-label="instagram" className="mx-2" style={{color: "#fd5949"}}>
              <FaInstagram size={24} />
            </a>
            <a href="https://pin.it/3QOYsggUZ" className="mx-2" aria-label="pinterest" style={{color:"#E60023"}}>
              <FaPinterestP size={24} />
            </a>
            <a href="https://youtube.com/@codeinputs" className="mx-2" aria-label="youtube" style={{color:"#FF0000"}}>
              <FaYoutube size={24} />
            </a>
            <a href="https://www.threads.net/@codeinputs_24" className="mx-2" aria-label="threads" style={{color:"#000000"}}>
              <FaThreads size={24}/>
            </a>
            <a href="https://whatsapp.com/channel/0029Vb7EnINKGGGAj336FR0f" aria-label="whatsapp" className="mx-2" style={{color:"#075E54"}}>
              <FaWhatsapp size={24} />
            </a>
          </Col>
        </Row>

        <Row className="text-center mt-3">
          <Col lg={12}>
            <span style={{color:"#C71585"}}>
              Copyright &copy; <a href="#your-link" style={{color:"#C71585"}}>Code Inputs</a>
            </span>
          </Col>
        </Row>
      </Container>
    </footer>
			);
};

export default Footer;